import { Ref, ref } from "vue";

/**
 * Hook pour manipuler une expression régulière réactive.
 *
 * @param regex Expression régulière initiale (RegExp)
 * @returns { refRegex, doChangeRegex }
 */
function useRegex(regex: RegExp = /.*/) {
  const refRegex: Ref<RegExp> = ref(regex);
  const doChangeRegex = function (newRegex: RegExp) {
    refRegex.value = newRegex;
  };
  return {
    refRegex,
    doChangeRegex,
  };
}
export default useRegex;
